<template>
  <div class="bg-white shadow sm:rounded-lg">
    <div class="px-4 py-5 sm:px-6">
      <h2
        id="timeline-title"
        class="text-lg leading-6 font-medium text-gray-900"
      >
        {{ $t('message.flow.flowrecordpanel.historia') }} {{ selectedorder }}
      </h2>
    </div>
    <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
      <!-- Activity Feed -->
      <div class="flow-root">
        <ul class="-mb-8">
          <li
            v-for="(item, index) in items"
            v-bind:key="index + item.blueprint"
          >
            <div class="relative pb-8">
              <span
                class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200"
                aria-hidden="true"
              ></span>
              <recordpanelitem
                :title="item.title"
                :time="item.timestamp"
                :subtitle="item.subtitle"
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import FlowRecordPanelItem from '@/components/flow/FlowRecordPanelItem';
export default {
  name: 'flow-record-panel',
  components: {
    recordpanelitem: FlowRecordPanelItem
  },
  props: {
    selectedorder: String
  },
  data() {
    return {
      items: []
    };
  },
  watch: {
    selectedorder() {
      this.fetchRecords();
    }
  },
  methods: {
    async fetchRecords() {
      this.items = [];
      const response = await this.$http.get(
        `/flow/custom/recordsbylote?lote=${this.selectedorder}`
      );
      this.items = response.data.records;
      console.log(JSON.parse(JSON.stringify(this.items)));
    }
  }
};
</script>
